module.exports = __webpack_public_path__ + "img/tizen-digital-signage-dark.9b8a2584.png";